function useFilterList() {
  /*
    取得 列表 篩選資料
    @params data: 被篩選的資料
    @params filterKey: 比對資料的 Key
    @params serachTerm: 搜尋字串
    @params isConsistent: 是否完全比對 (true/false)
  */
  const getFilterListData = ({
    data = [],
    filterKey = "",
    serachTerm = "",
    isConsistent = false,
  }) =>
    (data || []).filter((item) => {
      if (serachTerm === "" || serachTerm === null || serachTerm === undefined)
        return true;
      if (isConsistent) return item[filterKey] === serachTerm;
      else return item[filterKey]?.includes(serachTerm);
    });

  /*
    取得 Tree 篩選資料
    @params data: 被篩選的資料
    @params filterKey: 比對資料的 Key
    @params childKey: 子項目外層的 Key
    @params serachTerm: 搜尋字串
    @params isConsistent: 是否完全比對 (true/false)
  */
  const getFilterTreeData = ({
    data = [],
    filterKey = "",
    childKey = "child",
    serachTerm = "",
    isConsistent = false,
  }) => {
    let reVal = [];
    (data || []).forEach((item) => {
      let temp = null;
      if (item[childKey]) {
        temp = getFilterTreeData({
          data: item[childKey],
          filterKey,
          serachTerm,
          isConsistent,
        });
      }

      if (temp && temp.length > 0) {
        reVal.push({
          ...item,
          [childKey]: temp,
        });
      } else if (
        serachTerm === "" ||
        serachTerm === null ||
        serachTerm === undefined ||
        (isConsistent && item[filterKey] === serachTerm) ||
        (!isConsistent && item[filterKey]?.includes(serachTerm))
      ) {
        reVal.push({
          ...item,
          [childKey]: [],
        });
      }
    });

    return reVal;
  };

  return { getFilterListData, getFilterTreeData };
}

export default useFilterList;
